var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4851",
    "data-name": "Group 4851",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M129.535,138.989c-.423,1.631-4.713,1.752-4.411-.423.181-1.45.483-2.84.725-4.29.121-.906-.483-.6-.967-.785-.363-.181-.363-.6.06-.665a25.705,25.705,0,0,1,3.082-.06c.363,0,.544.181.544.483a1.94,1.94,0,0,1-.06.846c-.242,1.39-.6,2.84-.725,4.169-.06.3,0,.846.423.846a4.579,4.579,0,0,0,.967-.363C129.414,138.626,129.535,138.807,129.535,138.989Z",
    transform: "translate(-117.088 -124.729)",
    fill: "#ff8060",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M148.45,74a1.431,1.431,0,0,1,1.45,1.45,1.4,1.4,0,0,1-1.45,1.45,1.45,1.45,0,0,1,0-2.9Z",
    transform: "translate(-138.118 -69.529)",
    fill: "#ff8060",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M9.97,0A10,10,0,1,1,0,9.97,9.993,9.993,0,0,1,9.97,0Zm0,1.511A8.459,8.459,0,1,0,18.429,9.97,8.484,8.484,0,0,0,9.97,1.511Z",
    fill: "#ff8060"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.8de11629d06062d139a6ab1fb26a6f6a.svg";
export { ForwardRef as ReactComponent };